module.exports = __webpack_public_path__ + "img/logo_row_white.5a9b07aa.svg";